import { Enum } from '@lighthouse/tools'

import type { ButtonConfigure, CursorProtocol } from '../../protocols'
import type { AnchorProtocol, BaseBreakPointProtocol } from '../../protocols/blocks'
import type { EventsProtocol } from '../../protocols/event'
import { BlockType } from '../Basic'
import { BaseBlock } from './BaseBlock'
import type { BlockAbstract } from './Block'

export type ButtonBlockTriggerEvent = 'hover' | 'click'

export type ButtonBlockType = 'icon-name' | 'icon' | 'name'

export const ButtonSize = Enum('xs', 'sm', 'md', 'lg', 'xl', 'xxl')
export type ButtonSizeType = Enum<typeof ButtonSize>

export interface ButtonBlockConfigure extends ButtonConfigure {}

export interface ButtonBlockConfig extends BaseBreakPointProtocol, ButtonBlockConfigure, EventsProtocol, AnchorProtocol {
    floatPointerList?: string[]
    cursor?: CursorProtocol
}

export abstract class ButtonBlockAbstract extends BaseBlock {
    type = BlockType.button

    abstract override config: ButtonBlockConfig

    abstract children: BlockAbstract[]
}
